import { h } from 'preact'
import ButtonControl from '../button-control'
import Icon from "../assets";

interface Props {
  value?: Array<string> | string,
  placeholder?: string,
  onInput?: (e: Event) => void,
  onSubmit: Function,
  onClear?: OnClickCallback,
  isModerationOverview?: boolean
}

function handleSubmit (event: Event, onSubmit: Function) {
  event.preventDefault()

  const { target } = event
  const input = (target as HTMLElement).querySelector('input')

  if(!input) return

  const value = input.value.trim()

  if (!value) return

  onSubmit(value)
}

const SearchBox = ({ value, placeholder, onInput, onSubmit, onClear, isModerationOverview }: Props) => {
  return <div class='control-search-box'>
    <form onSubmit={(event => handleSubmit(event, onSubmit))}>
      { isModerationOverview && <Icon width={16} height={16} icon='search' /> }
      <input
          class='qa-search-box-filter'
          type='text'
          value={value}
          placeholder={placeholder}
          maxLength={500}
          onInput={onInput}
      />
      {isModerationOverview && value && <Icon
        icon='close'
        width={16}
        height={16}
        onClick={onClear} />
        }
      { !isModerationOverview && <ButtonControl variant='primary' type='submit' icon='search' /> }
    </form>
  </div>
}

export default SearchBox
